import React from 'react';
import { Link } from 'react-router-dom';
// import image

const ProductItem = ({ productItems }) => {
  return (
    <>
      {productItems === null ? (
        <div> Error </div>
      ) : (
        productItems.map((productItem, index) => (
          <div
            className="flex flex-col bg-white rounded pt-2 mx-2 my-2"
            key={index}
          >
            <div className="flex flex-col px-3 pb-2">
              <img
                src={productItem.imageProduct}
                alt="Brokoli"
                className="h-32"
              />
              <div className="flex flex-col mb-2">
                <p className="text-font-gray ">{productItem.nameProduct}</p>
                <p className="text-font-gray-light text-xs">
                  {productItem.weight}
                </p>
              </div>
            </div>
            <div className="flex flex-col px-3 mt-auto">
              {productItem.priceBefore && productItem.priceBefore.length > 0 ? (
                <p className="text-gray-400 text-sm line-through">
                  Rp {productItem.priceBefore}
                </p>
              ) : (
                <br />
              )}

              <p className="text-basic-orange ">Rp {productItem.priceAfter}</p>
            </div>
            <Link to="/sawi" className="mt-2">
              <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                Beli
              </div>
            </Link>
          </div>
        ))
      )}
    </>
  );
};

export default ProductItem;
